module.exports = __webpack_public_path__ + "static/media/2025_Arctic_Law.6f25084d.png";